<ng-template #popTemplate>Here we go: <div [innerHtml]="html"></div></ng-template>
<button type="button" class="btn btn-success"
        [popover]="popTemplate" popoverTitle="Dynamic html inside">
  Show me popover with html
</button>
